import './losscalculator.css'
import { Paper,Button,TableContainer,TableHead,TableRow,TableCell,TableBody,Table } from '@mui/material';
import { StyledTextField } from '../../StyledMUIComps.jsx';
import { useState } from 'react';

function LossCalculator() {
    const [buyHKDRate, setBuyHKDRate] = useState(undefined); // 使用状态管理 group
    const [midMarketRate, setMidMarketRate] = useState(undefined); // 使用状态管理 weight
    const [cadtoCNYRate, setCADtoCNYRate] = useState(undefined); // 使用状态管理 result
    const [amounttoRemit, setAmounttoRemit] = useState(undefined)
    const [hkbanks, setHongKongBanks] = useState({'received':'','loss':'','losspercent':''})
    const [wise, setWISE] = useState({'received':'','loss':'','losspercent':''})
    const [cabanks, setCABanks] = useState({'received':'','loss':'','losspercent':''})
    const [totalPercent, setTotalPercent] = useState(undefined)
    const [notice, setNotice] = useState('')

    const hkdRateChange = (event) => {
        setBuyHKDRate(event.target.value);
    }

    const midMarketChange = (event) => {
        setMidMarketRate(event.target.value);
    }

    const cadtoCNYChange = (event) => {
        setCADtoCNYRate(event.target.value);
    }

    const amounttoRemitChange = (event) => {
        setAmounttoRemit(event.target.value);
    }

    const Calculation = () => {
        setNotice('')
        setTotalPercent(undefined)
        setHongKongBanks({'received':'','loss':'','losspercent':''});
        setWISE({'received':'','loss':'','losspercent':''});
        setCABanks({'received':'','loss':'','losspercent':''});
        // 验证输入是否合法
        if (
            buyHKDRate === undefined ||
            midMarketRate === undefined ||
            cadtoCNYRate === undefined ||
            amounttoRemit === undefined ||
            buyHKDRate === '' ||
            midMarketRate === '' ||
            cadtoCNYRate === '' ||
            amounttoRemit === '' ||
            isNaN(buyHKDRate) ||
            isNaN(midMarketRate) ||
            isNaN(cadtoCNYRate) ||
            isNaN(amounttoRemit) ||
            parseFloat(buyHKDRate) <= 0 ||
            parseFloat(midMarketRate) <= 0 ||
            parseFloat(cadtoCNYRate) <= 0 ||
            parseFloat(amounttoRemit) <= 0 ||
            parseFloat(cadtoCNYRate)*1.21 >= parseFloat(amounttoRemit)
        ) {
            setNotice('Please input values correctly');
            return;
        }

        const hkddifference = (midMarketRate - buyHKDRate)/midMarketRate
        const hkLoss = hkddifference * amounttoRemit
        const hkReceived = amounttoRemit - hkLoss
        const hkpercent = hkLoss / amounttoRemit * 100
        const wiseLoss = hkReceived*0.22/100
        const wiseReceived = hkReceived - wiseLoss 
        const wisepercent = wiseLoss / amounttoRemit *100
        const caLoss = cadtoCNYRate * 1.21
        const caReceived = wiseReceived - caLoss
        const capercent = caLoss / amounttoRemit * 100
        setTotalPercent(hkpercent+wisepercent+capercent)

        setHongKongBanks({ loss: hkLoss.toFixed(2), received: hkReceived.toFixed(2),losspercent:hkpercent.toFixed(2) });
        setWISE({ loss: wiseLoss.toFixed(2), received: wiseReceived.toFixed(2),losspercent:wisepercent.toFixed(2)  });
        setCABanks({ loss: caLoss.toFixed(2), received: caReceived.toFixed(2),losspercent:capercent.toFixed(2)  });
        return
    };

    return (
        <div>
            <p className='articletitle' >
               CN banks to HK banks via FPS, HK banks to Canadian banks via WISE remit loss calculator
            </p>
            <hr className='divideline'/>
            <p className='nekopara'>
                Since WISE started to enable users to receive HKD via FPS proxy and PBOC and HKMA decided to realise game changing connection of China mainland's IBPS with Hong Kong's FPS making the transaction between mainland banks with HK banks no cost, there's a brand new way for mainland residents who own a Hong Kong bank account to remit globally with WISE at a low cost. Before this, only international banks' premium clients have the priority to remit globally in a low cost.
            </p>
            <p className='nekopara'>
                WISE is a great tool to make international transactions. However, low cost dosen't mean no cost. Hopefully if you will spend all your money with a cash back credit card, there is a chance that cash back will cover the cost for you. Here's a tool to help you to estimate how much you will cost when you remit.
            </p>
            <StyledTextField
                label="You buy HKD rate(from banks)"
                sx={{ m: 1, width: '25ch',fontFamily:'comicregular'}}
                onChange={hkdRateChange}
            />
            <StyledTextField
                label="Mid-market CNY to HKD rate"
                sx={{ m: 1, width: '25ch',fontFamily:'comicregular'}}
                onChange={midMarketChange}
            />
            <StyledTextField
                label="Mid-market CAD to CNY rate"
                sx={{ m: 1, width: '25ch',fontFamily:'comicregular'}}
                onChange={cadtoCNYChange}
            />
            <StyledTextField
                    label="Amount to remit from Chinese bank"
                    sx={{ m: 1, width: '25ch',fontFamily:'comicregular'}}
                    onChange={amounttoRemitChange}
            />
            <p
                style={{
                    fontFamily: 'comicbold',
                    fontSize: 'medium',
                    color: 'rgba(59,90,155 ,1)',
                }}
            >Results of remit losses</p>

            <TableContainer component={Paper}>
                <Table  size="small" aria-label="a dense table">
                <TableHead>
                    <TableRow>
                        <TableCell  align="left"></TableCell>
                        <TableCell  align="left">You send(in CNY)</TableCell>
                        <TableCell  align="left">Hong Kong banks received</TableCell>
                        <TableCell  align="left">WISE received</TableCell>  
                        <TableCell  align="left">Canadian banks received</TableCell>                     
                    </TableRow>
                </TableHead>
                <TableBody>
                    <TableRow  sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                        <TableCell  align="left">Received</TableCell>
                        <TableCell  align="left">{amounttoRemit}</TableCell>
                        <TableCell  align="left">{hkbanks.received}</TableCell>
                        <TableCell  align="left">{wise.received}</TableCell>
                        <TableCell  align="left">{cabanks.received}</TableCell>
                    </TableRow>
                    <TableRow  sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                        <TableCell  align="left">Loss</TableCell>
                        <TableCell  align="left"></TableCell>
                        <TableCell  align="left">{hkbanks.loss}</TableCell>
                        <TableCell  align="left">{wise.loss}</TableCell>
                        <TableCell  align="left">{cabanks.loss}</TableCell>
                    </TableRow>
                    <TableRow  sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                        <TableCell  align="left">Loss %</TableCell>
                        <TableCell  align="left"></TableCell>
                        <TableCell  align="left">{hkbanks.losspercent}</TableCell>
                        <TableCell  align="left">{wise.losspercent}</TableCell>
                        <TableCell  align="left">{cabanks.losspercent}</TableCell>
                    </TableRow>
                    <TableRow  sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                        <TableCell  align="left">Total Loss Percentage %</TableCell>
                        <TableCell  align="left">{totalPercent}</TableCell>
                    </TableRow>
                </TableBody>
                </Table>
            </TableContainer>
            
            <div>
                <p style={{ fontFamily: 'comicregular' }}>{notice}</p>
            </div>
            <Button onClick={Calculation} variant='contained' sx={{
                fontFamily:'comicbold',
                backgroundColor:'rgba(59,90,155 ,1)',
            }}>Calculate</Button>
        </div>
    );
}

export default LossCalculator;